import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserImportLog } from '../model/userImportLog';
import { UpdateLogRequest } from '../model/updateLogStateRequest';
import { ImportLogType } from '../common/enums';

@Component({
  selector: 'app-log-dialog',
  templateUrl: './log-dialog.component.html',
  styleUrls: ['./log-dialog.component.css']
})
export class LogDialogComponent {
  private readonly logList: UserImportLog[] = [];
  private readonly onResolveItems: any;

  public numberOfHandled: number = 0;
  public numberOfUnhandled: number = 0;
  public filteredLogList: UserImportLog[] = [];
  public showHandled: boolean = false;
  public modifiedLogList: UpdateLogRequest[] = [];
  public title: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    if (data.logs) {
      this.logList = data.logs;
    }
    if (data.title) {
      this.title = data.title;
    }
    if (data.onResolveItems) {
      this.onResolveItems = data.onResolveItems;
    }


    this.numberOfHandled = this.logList.filter(hill => hill.resolved && hill.type !== ImportLogType.LastImport).length;
    this.numberOfUnhandled = this.logList.filter(hill => !hill.resolved).length;

    this.createFilteredLogList();
  }

  private createFilteredLogList() {
    if (this.showHandled) {
      this.filteredLogList = this.logList;
    } else {
      this.filteredLogList = this.logList.filter(hill => hill.resolved === false);
    }
  }

  public canSave() : boolean {
    return this.modifiedLogList.length > 0;
  }

  public addToModifiedLogList(logId: number, event: any) {

    let modifiedExist = this.modifiedLogList.filter(mill => mill.logId === logId);

    if (modifiedExist.length === 0) {
      let logStateRequest: UpdateLogRequest = {
        logId: logId,
        logState: event.checked,
      }
      this.modifiedLogList.push(logStateRequest);
    } else {
      let index = this.modifiedLogList.indexOf(modifiedExist[0]);
      this.modifiedLogList.splice(index, 1);
    }
  }

  public toggleShowHandled() {
    this.showHandled = !this.showHandled;
    this.createFilteredLogList();
  }

  public updateResolvedState() {
    this.onResolveItems(this.modifiedLogList);
  }

  public getDate(log: UserImportLog) : string {
    return log.createdAt.toLocaleString();
  }

  public showResolveButton(log: UserImportLog) {
    return log.type !== ImportLogType.LastImport;
  }
}
